<div id="focustipContainer">
	<div id="focustipMessage" class="alert alert-danger">
		{{ data.text }}
	</div>
	<div id="boxleft"></div>
	<div id="boxtop"></div>
	<div id="boxright"></div>
	<div id="boxbottom"></div>
</div>
